module.exports = __webpack_public_path__ + "img/solution-zhiyinji.96b3f532.jpg";